import {
  createContext,
} from 'react';

export const AppContext = createContext({
  app: {
    saldoCaixa: 0,
    mensagemInicialFc: '',
    saldoIndicadorRetirada: 1500,
    meiosPagamento: [],
    limiteInferiorNotaCpf: 5000,
    limiteSuperiorNotaCpf: 10000,
    videosTutoriais: [],
    contasPixADistancia: [],
    modoOffline: false,
    isBuscouDadosConfig: false,
    valorMaximoPesoNoFc: 25,
    criarVendaPermissao: false,
    consultarPrecosPermissao: false,
    utilizarTrocoPermissao: false,
    utilizarTrocoAberturaCaixaPermissao: false,
    criarPedidoPermissao: false,
    criarRetiradaPermissao: false,
    carregarPedidoPermissao: false,
    criarClientePermissao: false,
    editarClientePermissao: false,
    tipoPagamentoDinheiroPermissao: false,
    tipoPagamentoCartaoCreditoPermissao: false,
    tipoPagamentoCartaoDebitoPermissao: false,
    tipoPagamentoPixQrcodePermissao: false,
    tipoPagamentoVoucherPermissao: false,
    tipoPagamentoDevolucaoPermissao: false,
    tipoPagamentoPixDistanciaPermissao: false,
    tipoPagamentoCreditoFidelidadePermissao: false,
    pesquisaPorNomes: false,
    tipoCaixa: '',
    nomeCaixa: '',
    isBuscouDadosPermissoes: false,
    pesquisaPorCodigoDeBalancaPermissao: false,
    conferenciaGrandesPesagensPermissao: false,
    pagarDescarregoMercadoriaPermissao: false,
    IdTerminalSitef: '',
    IPSiTef: '',
    IdLoja: '',
    cnpjEstabelecimento: '',
    cnpjAC: '',
    tokenTlsFiserv: '',
    pendenciasTEFResolvidas: true,
    usar_tef: false,
    usar_nova_impressao: false,
    contador_atualizacao_info_tef: 0,
    usar_biometria: true,
    valor_venda_com_taxa_sistema_fidelidade: 300,
    valor_venda_sem_taxa_sistema_fidelidade: 100,
    interfaceSitef: null
  },
  dispatch: (data) => {},
  openConsultorPrecos: () => {},
});
